<template>
  <div class="card">
    <!-- Header -->
    <div v-if="includeHeader" class="card-header">
      <div v-if="loaded">
        <div class="d-flex">
          <div>
            <router-link class="h3" :to="jobUrl">{{job.name ? job.name : `Job ${job.jobId}`}}</router-link>
          </div>
          <div class="ml-auto">
            <badge :type="snapshot | snapshotStatusDescription | badgeTypeForStatusDescription" class="badge-pill w-100">
              {{snapshot | snapshotStatusDescription}}
            </badge>

<!--        TODO: remove this mocked section of badges  -->
<!--            <badge class="badge-pill w-100" type="primary">Waiting</badge>-->
<!--            <hr class="m-1">-->
<!--            <badge class="ml-auto badge-pill w-100" type="primary">Paused</badge>-->
<!--            <hr class="m-1">-->
<!--            <badge class="ml-auto badge-pill w-100" type="success">Working</badge>-->
<!--            <hr class="m-1">-->
<!--            <badge class="ml-auto badge-pill w-100" type="default">Done</badge>-->
<!--            <hr class="m-1">-->
<!--            <badge class="ml-auto badge-pill w-100" type="warning">Canceled</badge>-->
<!--            <hr class="m-1">-->
<!--            <badge class="ml-auto badge-pill w-100" type="danger">Errored</badge>-->

          </div>
        </div>
        <div class="d-flex test-muted">
          <small v-if="timeLabel">{{ timeLabel }}</small>
        </div>
      </div>
      <div v-else-if="loadError !== undefined">
        <b-card-text >{{loadError.message ? loadError.message : "Something went wrong... Contact us if this continues."}}</b-card-text>
      </div>
      <div v-else class="text-center p-3">
        <b-spinner size="sm"></b-spinner>
      </div>
    </div>

    <!-- Body -->
    <div v-if="loaded" class="card-body mx-4">
      <div v-for="(task, index) in allTasks" :key="index" class="row">
        <task-list-group-item :task="task"></task-list-group-item>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { snapshotTasks, snapshotStatusDescription } from '#/models/jobs/snapshot';
import { STATUS_DESCRIPTION } from '#/models/jobs/task';

import { JobGetRequest } from '#/protobuf/service_query_pb';
import { JobInfoQueryExpansionRequest } from '#/protobuf/job_pb';
import { EntityInfoExpansionRequest } from '#/protobuf/entity_pb';
import TaskListGroupItem from '#/ui/Components/Tasks/TaskListGroupItem.vue';
import { JobGetSession } from '#/services/jobs';

export default {
  components: { TaskListGroupItem },
  props: {
    jobId: {
      type: String,
      required: true,
    },
    includeHeader: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    // TODO: MAKE JOB STATUS BITWISE, need bitwise for tasks to do, and bitwise for tasks in process.
    // TODO: progress bar not animated if that task is done
    return {
      // loaded: false,
      // loadError: undefined,
      session: new JobGetSession(this.jobId),
    };
  },
  computed: {
    ...mapGetters('live', [
      'snapshotById',
    ]),
    ...mapGetters('jobs', [
      'jobById',
    ]),
    allTasks() {
      return snapshotTasks(this.snapshot);
    },
    loadError() {
      return this.session.error;
    },
    loaded() {
      // TODO: should i just flip this out for session.loaded now?
      return (!this.loadError && this.job !== undefined && this.snapshot !== undefined);
    },
    snapshot() {
      return this.snapshotById(this.jobId);
    },
    job() {
      return this.jobById(this.jobId);
    },
    jobUrl() {
      return `/jobs/${this.jobId}`;
    },
    timeLabel() {
      if (!this.loaded) {
        return undefined;
      }
      const status = snapshotStatusDescription(this.snapshot);
      if (status === STATUS_DESCRIPTION.DONE || status === STATUS_DESCRIPTION.CANCELED) {
        if (this.job.dateFinished && this.snapshot.dateFinished !== '') {
          return `finished ${this.$moment(this.job.dateFinished).fromNow()}`;
        }
      }
      if (status === STATUS_DESCRIPTION.WORKING) {
        if (this.snapshot.secondsRemaining && this.snapshot.secondsRemaining > 0) {
          const est = new Date();
          est.setSeconds(this.snapshot.secondsRemaining);
          return `${this.$moment(est).toNow(true)} left`;
        }
      }
      if (this.snapshot.snapTimestamp && this.snapshot.snapTimestamp !== '') {
        return `last updated ${this.$moment(this.snapshot.snapTimestamp).fromNow()}`;
      }
      return undefined;
    },
  },
  created() {
    return this.session.load();
    console.log('created live job card... loading backing data', this.jobId);
    const entityExpansion = new EntityInfoExpansionRequest();
    entityExpansion.setShouldExpandThumbnail(true);
    const expansionRequest = new JobInfoQueryExpansionRequest();
    expansionRequest.setShouldExpandKeyEntity(entityExpansion);
    expansionRequest.setShouldExpandReports(true);
    expansionRequest.setShouldExpandJobFolders(true);
    expansionRequest.setShouldExpandTags(true);
    expansionRequest.setShouldExpandVolumeMapping(true);
    expansionRequest.setShouldExpandNotes(true);
    const request = new JobGetRequest();
    request.setExpansionRequest(expansionRequest);
    request.setJobIdsList([this.jobId]);

    const jobPromise = this.$store.dispatch('jobs/loadDetails', request);
    jobPromise.then((response) => {
      console.log('live job card received backing job', this.job);
    }).catch((error) => {
      console.log('promise rejected for live job card backing job: ', this.jobId, error);
      this.loadError = error;
    }).finally(() => {

    });
  },
};

</script>
<style lang="scss" scoped>
$brand-primary: tomato;
$white: #fff;
$grey-light: #ededed;
%remain-steps{
  &:before {
    content: counter(stepNum);
    font-family: inherit;
    font-weight: 700;
  }
  &:after{
    background-color: $grey-light;
  }
}
.multi-steps{
  display: table;
  table-layout: auto;
  width: 100%;
  > li{
    counter-increment: stepNum;
    text-align: center;
    display: table-cell;
    position: relative;
    color: $brand-primary;

    &:before{
      content: '\f00c';
      content: '\2713;';
      content: '\10003';
      content: '\10004';
      content: '\2713';
      display: block;
      margin: 0 auto 4px;
      background-color: $white;
      width: 36px;
      height: 36px;
      line-height: 32px;
      text-align: center;
      font-weight: bold;
      border:{
        width: 2px;
        style: solid;
        color: $brand-primary;
        radius: 50%;
      }
    }
    &:after{
      content: '';
      height: 2px;
      width: 100%;
      background-color: $brand-primary;
      position: absolute;
      top: 16px;
      left: 50%;
      z-index: -1;
    }
    &:last-child{
      &:after{
        display: none;
      }
    }

    &.is-active{
      @extend %remain-steps;
      &:before{
        background-color: $white;
        border-color: $brand-primary;
      }

      ~ li{
        color: #808080;
        @extend %remain-steps;
        &:before{
          background-color: $grey-light;
          border-color: $grey-light;
        }
      }
    }
  }
}
</style>
